var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPancake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_19)",
    filter: "url(#filter0_d_641_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 31.3158C17.5367 31.3158 13.4407 30.8758 10.2324 30.1422C10.694 31.3578 11.5612 32.2772 12.6304 32.5714C15.0437 33.2355 18.351 33.645 21.9998 33.645C25.6487 33.645 28.9559 33.2355 31.3692 32.5714C32.4385 32.2772 33.3057 31.3578 33.7672 30.1422C30.5589 30.8758 26.463 31.3158 21.9998 31.3158Z",
    fill: "url(#paint0_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 27.8686C40 34.0395 4 34.0395 4 27.8686C4 21.6976 40 21.6976 40 27.8686Z",
    fill: "url(#paint1_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5295 27.4159C37.5295 31.8155 6.4707 31.8155 6.4707 27.4159C6.4707 23.0163 37.5295 23.0163 37.5295 27.4159Z",
    fill: "url(#paint2_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9995 27.8685C39.9995 22.9944 17.541 21.9702 8.10133 24.7957C8.1254 24.8237 8.14961 24.8517 8.17573 24.8792C7.68126 25.2697 7.40625 25.707 7.40625 26.1914C7.40625 26.6443 7.64653 27.056 8.08157 27.4269L12.5263 31.8717C23.1718 33.4219 39.9995 32.0877 39.9995 27.8685Z",
    fill: "url(#paint3_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5945 26.1915C36.5945 31.1945 7.4082 31.1945 7.4082 26.1915C7.4082 21.1885 36.5945 21.1885 36.5945 26.1915Z",
    fill: "url(#paint4_linear_641_19)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M31.873 25.1398C32.1395 25.1398 32.3554 24.8734 32.3554 24.5448C32.3554 24.2162 32.1395 23.9498 31.873 23.9498C31.6066 23.9498 31.3906 24.2162 31.3906 24.5448C31.3906 24.8734 31.6066 25.1398 31.873 25.1398Z",
    fill: "url(#paint5_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30.9765 26.5533C31.1868 26.5533 31.3573 26.343 31.3573 26.0835C31.3573 25.8241 31.1868 25.6138 30.9765 25.6138C30.7662 25.6138 30.5957 25.8241 30.5957 26.0835C30.5957 26.343 30.7662 26.5533 30.9765 26.5533Z",
    fill: "url(#paint6_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M32.6359 26.7609C32.7627 26.7609 32.8655 26.6341 32.8655 26.4777C32.8655 26.3213 32.7627 26.1945 32.6359 26.1945C32.5091 26.1945 32.4062 26.3213 32.4062 26.4777C32.4062 26.6341 32.5091 26.7609 32.6359 26.7609Z",
    fill: "url(#paint7_linear_641_19)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M34.4229 25.433C34.6198 25.433 34.7793 25.2361 34.7793 24.9933C34.7793 24.7504 34.6198 24.5536 34.4229 24.5536C34.226 24.5536 34.0664 24.7504 34.0664 24.9933C34.0664 25.2361 34.226 25.433 34.4229 25.433Z",
    fill: "url(#paint8_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M33.2951 25.4899C33.4505 25.4899 33.5765 25.3345 33.5765 25.1429C33.5765 24.9512 33.4505 24.7958 33.2951 24.7958C33.1397 24.7958 33.0137 24.9512 33.0137 25.1429C33.0137 25.3345 33.1397 25.4899 33.2951 25.4899Z",
    fill: "url(#paint9_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M33.9372 26.674C34.0309 26.674 34.1068 26.5803 34.1068 26.4647C34.1068 26.3491 34.0309 26.2554 33.9372 26.2554C33.8435 26.2554 33.7676 26.3491 33.7676 26.4647C33.7676 26.5803 33.8435 26.674 33.9372 26.674Z",
    fill: "url(#paint10_linear_641_19)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.5926 26.1915C36.5926 25.0436 35.0557 24.1594 32.688 23.5382H11.3108C8.94324 24.1593 7.40625 25.0436 7.40625 26.1914C7.40632 31.1945 36.5926 31.1945 36.5926 26.1915Z",
    fill: "url(#paint11_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5945 23.5383C36.5945 28.5413 7.4082 28.5413 7.4082 23.5383C7.4082 18.5353 36.5945 18.5353 36.5945 23.5383Z",
    fill: "url(#paint12_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5926 23.5382C36.5926 22.3903 35.0557 21.5061 32.688 20.8849H11.3108C8.94324 21.506 7.40625 22.3903 7.40625 23.5381C7.40632 28.5412 36.5926 28.5412 36.5926 23.5382Z",
    fill: "url(#paint13_linear_641_19)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12.5019 24.4698C12.7684 24.4698 12.9843 24.2629 12.9843 24.0077C12.9843 23.7524 12.7684 23.5455 12.5019 23.5455C12.2355 23.5455 12.0195 23.7524 12.0195 24.0077C12.0195 24.2629 12.2355 24.4698 12.5019 24.4698Z",
    fill: "url(#paint14_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.6054 25.5675C11.8158 25.5675 11.9863 25.4042 11.9863 25.2027C11.9863 25.0012 11.8158 24.8379 11.6054 24.8379C11.3951 24.8379 11.2246 25.0012 11.2246 25.2027C11.2246 25.4042 11.3951 25.5675 11.6054 25.5675Z",
    fill: "url(#paint15_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.2648 25.7288C13.3916 25.7288 13.4944 25.6304 13.4944 25.5089C13.4944 25.3874 13.3916 25.2889 13.2648 25.2889C13.138 25.2889 13.0352 25.3874 13.0352 25.5089C13.0352 25.6304 13.138 25.7288 13.2648 25.7288Z",
    fill: "url(#paint16_linear_641_19)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.0518 24.6974C15.2487 24.6974 15.4083 24.5445 15.4083 24.3559C15.4083 24.1673 15.2487 24.0144 15.0518 24.0144C14.8549 24.0144 14.6953 24.1673 14.6953 24.3559C14.6953 24.5445 14.8549 24.6974 15.0518 24.6974Z",
    fill: "url(#paint17_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.924 24.7417C14.0794 24.7417 14.2054 24.621 14.2054 24.4721C14.2054 24.3232 14.0794 24.2025 13.924 24.2025C13.7686 24.2025 13.6426 24.3232 13.6426 24.4721C13.6426 24.621 13.7686 24.7417 13.924 24.7417Z",
    fill: "url(#paint18_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.5661 25.6612C14.6598 25.6612 14.7357 25.5884 14.7357 25.4987C14.7357 25.4089 14.6598 25.3362 14.5661 25.3362C14.4724 25.3362 14.3965 25.4089 14.3965 25.4987C14.3965 25.5884 14.4724 25.6612 14.5661 25.6612Z",
    fill: "url(#paint19_linear_641_19)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.5945 20.8851C36.5945 25.8881 7.4082 25.8881 7.4082 20.8851C7.4082 15.8821 36.5945 15.8821 36.5945 20.8851Z",
    fill: "url(#paint20_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5926 20.8851C36.5926 19.7372 35.0557 18.853 32.688 18.2318H11.3108C8.94324 18.8529 7.40625 19.7372 7.40625 20.885C7.40632 25.8881 36.5926 25.8881 36.5926 20.8851Z",
    fill: "url(#paint21_linear_641_19)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.8262 22.6203C23.0926 22.6203 23.3086 22.4134 23.3086 22.1582C23.3086 21.903 23.0926 21.696 22.8262 21.696C22.5597 21.696 22.3438 21.903 22.3438 22.1582C22.3438 22.4134 22.5597 22.6203 22.8262 22.6203Z",
    fill: "url(#paint22_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M21.9297 23.718C22.14 23.718 22.3105 23.5547 22.3105 23.3532C22.3105 23.1517 22.14 22.9884 21.9297 22.9884C21.7193 22.9884 21.5488 23.1517 21.5488 23.3532C21.5488 23.5547 21.7193 23.718 21.9297 23.718Z",
    fill: "url(#paint23_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M23.589 23.8792C23.7158 23.8792 23.8186 23.7808 23.8186 23.6593C23.8186 23.5378 23.7158 23.4393 23.589 23.4393C23.4622 23.4393 23.3594 23.5378 23.3594 23.6593C23.3594 23.7808 23.4622 23.8792 23.589 23.8792Z",
    fill: "url(#paint24_linear_641_19)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.5945 18.2319C36.5945 23.2349 7.4082 23.2349 7.4082 18.2319C7.4082 13.2289 36.5945 13.2289 36.5945 18.2319Z",
    fill: "url(#paint25_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5926 18.2318C36.5926 17.0839 35.0557 16.1997 32.688 15.5785H11.3108C8.94324 16.1996 7.40625 17.0839 7.40625 18.2317C7.40632 23.2348 36.5926 23.2348 36.5926 18.2318Z",
    fill: "url(#paint26_linear_641_19)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M34.4229 17.6822C34.6198 17.6822 34.7793 17.5163 34.7793 17.3117C34.7793 17.107 34.6198 16.9412 34.4229 16.9412C34.226 16.9412 34.0664 17.107 34.0664 17.3117C34.0664 17.5163 34.226 17.6822 34.4229 17.6822Z",
    fill: "url(#paint27_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M33.2951 17.7303C33.4505 17.7303 33.5765 17.5993 33.5765 17.4378C33.5765 17.2763 33.4505 17.1454 33.2951 17.1454C33.1397 17.1454 33.0137 17.2763 33.0137 17.4378C33.0137 17.5993 33.1397 17.7303 33.2951 17.7303Z",
    fill: "url(#paint28_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M33.9372 18.7279C34.0309 18.7279 34.1068 18.649 34.1068 18.5516C34.1068 18.4542 34.0309 18.3752 33.9372 18.3752C33.8435 18.3752 33.7676 18.4542 33.7676 18.5516C33.7676 18.649 33.8435 18.7279 33.9372 18.7279Z",
    fill: "url(#paint29_linear_641_19)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.5945 15.5786C36.5945 20.5816 7.4082 20.5816 7.4082 15.5786C7.4082 10.5755 36.5945 10.5755 36.5945 15.5786Z",
    fill: "url(#paint30_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5926 15.5786C36.5926 14.4307 35.0557 13.5465 32.688 12.9253H11.3108C8.94324 13.5464 7.40625 14.4307 7.40625 15.5785C7.40632 20.5816 36.5926 20.5816 36.5926 15.5786Z",
    fill: "url(#paint31_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5945 12.9254C36.5945 17.9284 7.4082 17.9284 7.4082 12.9254C7.4082 7.92237 36.5945 7.9223 36.5945 12.9254Z",
    fill: "url(#paint32_linear_641_19)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M31.873 11.8736C32.1395 11.8736 32.3554 11.6072 32.3554 11.2786C32.3554 10.95 32.1395 10.6836 31.873 10.6836C31.6066 10.6836 31.3906 10.95 31.3906 11.2786C31.3906 11.6072 31.6066 11.8736 31.873 11.8736Z",
    fill: "url(#paint33_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30.9765 13.2871C31.1868 13.2871 31.3573 13.0767 31.3573 12.8173C31.3573 12.5579 31.1868 12.3475 30.9765 12.3475C30.7662 12.3475 30.5957 12.5579 30.5957 12.8173C30.5957 13.0767 30.7662 13.2871 30.9765 13.2871Z",
    fill: "url(#paint34_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M32.6359 13.4947C32.7627 13.4947 32.8655 13.368 32.8655 13.2115C32.8655 13.0551 32.7627 12.9283 32.6359 12.9283C32.5091 12.9283 32.4062 13.0551 32.4062 13.2115C32.4062 13.368 32.5091 13.4947 32.6359 13.4947Z",
    fill: "url(#paint35_linear_641_19)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M34.4229 12.1667C34.6198 12.1667 34.7793 11.9699 34.7793 11.727C34.7793 11.4842 34.6198 11.2874 34.4229 11.2874C34.226 11.2874 34.0664 11.4842 34.0664 11.727C34.0664 11.9699 34.226 12.1667 34.4229 12.1667Z",
    fill: "url(#paint36_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M33.2951 12.2237C33.4505 12.2237 33.5765 12.0683 33.5765 11.8766C33.5765 11.6849 33.4505 11.5295 33.2951 11.5295C33.1397 11.5295 33.0137 11.6849 33.0137 11.8766C33.0137 12.0683 33.1397 12.2237 33.2951 12.2237Z",
    fill: "url(#paint37_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M33.9372 13.4077C34.0309 13.4077 34.1068 13.314 34.1068 13.1984C34.1068 13.0828 34.0309 12.9891 33.9372 12.9891C33.8435 12.9891 33.7676 13.0828 33.7676 13.1984C33.7676 13.314 33.8435 13.4077 33.9372 13.4077Z",
    fill: "url(#paint38_linear_641_19)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.5926 12.9254C36.5926 11.7775 35.0557 10.8933 32.688 10.2721H11.3108C8.94324 10.8932 7.40625 11.7775 7.40625 12.9253C7.40632 17.9284 36.5926 17.9284 36.5926 12.9254Z",
    fill: "url(#paint39_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.594 26.1915C36.594 25.7012 36.3127 25.2591 35.8068 24.8649C36.3125 24.4707 36.594 24.0286 36.594 23.5383C36.594 23.0479 36.3127 22.6059 35.8068 22.2117C36.3125 21.8175 36.594 21.3754 36.594 20.8851C36.594 20.3947 36.3127 19.9527 35.8068 19.5585C36.3125 19.1643 36.594 18.7222 36.594 18.2319C36.594 17.7416 36.3127 17.2995 35.8068 16.9053C36.3125 16.5111 36.594 16.069 36.594 15.5787C36.594 15.0883 36.3127 14.6463 35.8068 14.2521C36.3125 13.8579 36.594 13.4158 36.594 12.9255C36.594 8.80035 16.7525 8.07668 9.78906 10.7542V18.2189C9.78906 18.6472 10.0017 19.0252 10.3265 19.2554L21.0072 29.9361C28.6195 30.0548 36.594 28.8067 36.594 26.1915Z",
    fill: "url(#paint40_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5933 12.9254C36.5933 10.1321 27.4956 8.89864 19.459 9.22455V24.7948C19.459 25.2183 19.6667 25.592 19.9847 25.8228L24.0716 29.9098C30.6161 29.6949 36.5933 28.4557 36.5933 26.1916C36.5933 25.7013 36.312 25.2592 35.8061 24.8651C36.3119 24.4708 36.5933 24.0288 36.5933 23.5384C36.5933 23.0481 36.312 22.606 35.8061 22.2119C36.3119 21.8176 36.5933 21.3756 36.5933 20.8852C36.5933 20.3949 36.312 19.9528 35.8061 19.5587C36.3119 19.1644 36.5933 18.7224 36.5933 18.232C36.5933 17.7417 36.312 17.2996 35.8061 16.9055C36.3119 16.5112 36.5933 16.0692 36.5933 15.5788C36.5933 15.0885 36.312 14.6464 35.8061 14.2523C36.3119 13.8578 36.5933 13.4157 36.5933 12.9254Z",
    fill: "url(#paint41_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5938 26.1915C36.5938 25.7011 36.3125 25.2591 35.8066 24.8648C36.3124 24.4706 36.5938 24.0286 36.5938 23.5382C36.5938 23.0478 36.3125 22.6058 35.8066 22.2116C36.3124 21.8174 36.5938 21.3754 36.5938 20.885C36.5938 20.3946 36.3125 19.9526 35.8066 19.5584C36.3124 19.1642 36.5938 18.7222 36.5938 18.2318C36.5938 17.7415 36.3125 17.2994 35.8066 16.9052C36.3124 16.511 36.5938 16.069 36.5938 15.5786C36.5938 15.0882 36.3125 14.6462 35.8066 14.252C36.3124 13.8578 36.5938 13.4158 36.5938 12.9254C36.5938 10.6118 30.3527 9.3683 23.6426 9.19458V17.2814C23.6426 17.689 23.8353 18.0508 24.1337 18.2833L34.2132 28.3626C35.6949 27.7929 36.5938 27.0693 36.5938 26.1915Z",
    fill: "url(#paint42_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5939 18.2318C36.5939 17.7415 36.3126 17.2994 35.8067 16.9053C36.3124 16.511 36.5939 16.069 36.5939 15.5786C36.5939 15.0883 36.3126 14.6462 35.8067 14.2521C36.3124 13.8578 36.5939 13.4158 36.5939 12.9254C36.5939 11.6735 34.7658 10.7351 32.0254 10.1097V14.104C32.0254 14.488 32.1964 14.8313 32.4656 15.0643L36.3675 18.9662C36.5151 18.7347 36.5939 18.49 36.5939 18.2318Z",
    fill: "url(#paint43_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5925 10.2722C36.5925 5.26914 7.40625 5.26914 7.40625 10.2722C7.40625 10.9971 8.01966 11.6169 9.0679 12.1317C9.50604 12.3468 9.78761 12.7883 9.78761 13.2765V18.2188C9.78761 18.9205 10.3565 19.4894 11.0582 19.4894C11.7599 19.4894 12.3288 18.9205 12.3288 18.2188V16.2655C12.3288 14.6812 13.7146 13.4562 15.2875 13.6464C15.8567 13.7152 16.4432 13.7747 17.0425 13.8247C18.4084 13.9388 19.4582 15.083 19.4582 16.4538V24.7951C19.4582 25.4968 20.0271 26.0657 20.7288 26.0657C21.4305 26.0657 21.9994 25.4968 21.9994 24.7951V16.8805C21.9994 16.4272 22.3669 16.0596 22.8202 16.0596C23.2736 16.0596 23.6411 16.4271 23.6411 16.8805V17.2811C23.6411 17.9828 24.21 18.5517 24.9117 18.5517C25.6134 18.5517 26.1823 17.9828 26.1823 17.2811V16.7303C26.1823 15.1466 27.3643 13.8173 28.9355 13.6189C29.672 13.5258 30.3779 13.4169 31.0424 13.2918C31.5524 13.1958 32.024 13.5851 32.024 14.104C32.024 14.8058 32.5929 15.3746 33.2946 15.3746C33.9963 15.3746 34.5652 14.8058 34.5652 14.104V14.0966C34.5652 13.114 35.0354 12.2007 35.8097 11.5958C36.3133 11.2024 36.5925 10.7613 36.5925 10.2722Z",
    fill: "url(#paint44_radial_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5936 10.2719C36.5936 10.7611 36.314 11.2023 35.8107 11.5961C35.0364 12.2004 34.5663 13.1138 34.5663 14.0964V14.1041C34.5663 14.1437 34.5641 14.1832 34.5606 14.222C34.5331 14.5255 34.3976 14.7987 34.1943 15.0027C33.9641 15.2328 33.6465 15.3747 33.2957 15.3747C32.9441 15.3747 32.6265 15.2328 32.3971 15.0027C32.167 14.7726 32.0251 14.455 32.0251 14.1041C32.0251 13.5846 31.5528 13.1957 31.0432 13.2917C30.3783 13.4166 29.6731 13.526 28.9361 13.6185C27.9649 13.7413 27.1418 14.2961 26.6554 15.0768L19.1336 7.55496C18.8667 7.33966 18.715 7.07002 18.734 6.73119C18.7361 6.68884 18.7404 6.64649 18.7467 6.60484C21.4976 6.45943 24.4107 6.50107 27.0677 6.72907C32.3329 7.17943 36.5936 8.36037 36.5936 10.2719Z",
    fill: "url(#paint45_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.357 5.03896C20.877 5.55891 20.877 6.40188 20.357 6.92176C19.8371 7.44171 18.9941 7.44171 18.4742 6.92176C17.9543 6.40181 17.1887 4.79324 17.7086 4.27329C18.2285 3.75334 19.8372 4.51908 20.357 5.03896Z",
    fill: "url(#paint46_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2992 5.03593C21.3226 5.86012 20.9425 6.5396 20.4503 6.55357C19.9581 6.56755 19.5401 5.91073 19.5167 5.08647C19.4934 4.26221 19.839 2.36903 20.3312 2.35506C20.8234 2.34115 21.2759 4.21167 21.2992 5.03593Z",
    fill: "url(#paint47_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1054 3.7562C23.0142 3.7531 22.923 3.76227 22.8345 3.78451C22.1392 3.95879 18.8391 4.88209 18.7341 6.7315C18.6686 7.88336 20.5715 8.23955 22.27 8.32905C23.8211 8.41079 25.1594 7.58399 25.2503 6.49058C25.3532 5.25211 25.0461 3.8227 23.1054 3.7562Z",
    fill: "url(#paint48_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1055 3.7562C23.0143 3.7531 22.9231 3.76227 22.8345 3.78451C22.1392 3.95879 18.8391 4.88209 18.7341 6.7315C18.6686 7.88336 20.5715 8.23954 22.27 8.32905C23.821 8.41079 25.0461 3.8227 23.1055 3.7562Z",
    fill: "url(#paint49_linear_641_19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81037 9.30097C7.54778 9.60048 7.40625 9.92413 7.40625 10.272C7.40625 10.9969 8.01966 11.6167 9.06783 12.1315C9.50597 12.3466 9.78761 12.7881 9.78761 13.2763V18.2186C9.78761 18.9203 10.3565 19.4892 11.0582 19.4892C11.7599 19.4892 12.3288 18.9203 12.3288 18.2186V16.2654C12.3288 14.681 13.7146 13.456 15.2875 13.6462C15.8567 13.7151 16.4432 13.7745 17.0425 13.8246C18.4084 13.9386 19.4582 15.0829 19.4582 16.4536V24.795C19.4582 25.4967 20.0271 26.0655 20.7288 26.0655C21.4305 26.0655 21.9994 25.4967 21.9994 24.795V16.8803C21.9994 16.427 22.3669 16.0594 22.8202 16.0594C23.2736 16.0594 23.6411 16.4269 23.6411 16.8803V17.2809C23.6411 17.9826 24.21 18.5515 24.9117 18.5515C25.6134 18.5515 26.1823 17.9826 26.1823 17.2809V16.7301C26.1823 15.1464 27.3643 13.8171 28.9355 13.6187C29.672 13.5257 30.3779 13.4167 31.0424 13.2916C31.5524 13.1956 32.024 13.5849 32.024 14.1039C32.024 14.8056 32.5929 15.3745 33.2946 15.3745C33.9963 15.3745 34.5652 14.8056 34.5652 14.1039V14.0964C34.5652 13.1139 35.0354 12.2005 35.8097 11.5957C36.3133 11.2023 36.5925 10.761 36.5925 10.2719C36.5925 9.92406 36.451 9.60041 36.1884 9.3009C32.9369 13.0092 11.0619 13.0092 7.81037 9.30097Z",
    fill: "url(#paint50_linear_641_19)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_641_19",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_19"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_641_19",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_19",
    x1: 22.0669,
    y1: 31.2485,
    x2: 22.2081,
    y2: 33.5779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_641_19",
    x1: 20.8174,
    y1: 23.4054,
    x2: 23.5906,
    y2: 33.8718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_641_19",
    x1: 22.7744,
    y1: 33.61,
    x2: 21.4332,
    y2: 22.8806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_641_19",
    x1: 24.2691,
    y1: 31.2858,
    x2: 22.1515,
    y2: 15.3329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_641_19",
    x1: 21.0426,
    y1: 22.573,
    x2: 23.2909,
    y2: 31.0585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_641_19",
    x1: 32.4213,
    y1: 25.2711,
    x2: 30.9786,
    y2: 23.0199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_641_19",
    x1: 31.4267,
    y1: 26.6582,
    x2: 30.2878,
    y2: 24.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_641_19",
    x1: 32.9415,
    y1: 26.8254,
    x2: 32.2549,
    y2: 25.7539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_641_19",
    x1: 34.3001,
    y1: 25.6303,
    x2: 34.8504,
    y2: 23.6494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_641_19",
    x1: 33.2092,
    y1: 25.646,
    x2: 33.6438,
    y2: 24.0823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_641_19",
    x1: 33.9073,
    y1: 26.7684,
    x2: 34.1692,
    y2: 25.8256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_641_19",
    x1: 21.9995,
    y1: 28.5176,
    x2: 21.9995,
    y2: 31.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F32816",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    stopColor: "#E3281D",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#CA2728",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_641_19",
    x1: 21.0426,
    y1: 19.9198,
    x2: 23.2909,
    y2: 28.4053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_641_19",
    x1: 21.9995,
    y1: 26.0234,
    x2: 21.9995,
    y2: 28.6587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F32816",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    stopColor: "#E3281D",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#CA2728",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_641_19",
    x1: 12.9608,
    y1: 24.6121,
    x2: 11.7648,
    y2: 22.7456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_641_19",
    x1: 11.983,
    y1: 25.6814,
    x2: 11.0388,
    y2: 24.2079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_641_19",
    x1: 13.5226,
    y1: 25.7993,
    x2: 12.9533,
    y2: 24.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_641_19",
    x1: 14.9606,
    y1: 24.862,
    x2: 15.3948,
    y2: 23.2992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_641_19",
    x1: 13.8619,
    y1: 24.8726,
    x2: 14.2047,
    y2: 23.6389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_641_19",
    x1: 14.5481,
    y1: 25.7418,
    x2: 14.7548,
    y2: 24.9979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_641_19",
    x1: 21.0426,
    y1: 17.2666,
    x2: 23.2909,
    y2: 25.7521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_641_19",
    x1: 21.9994,
    y1: 23.2471,
    x2: 21.9994,
    y2: 26.5416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F32816",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    stopColor: "#E3281D",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#CA2728",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_641_19",
    x1: 23.2901,
    y1: 22.7604,
    x2: 22.0941,
    y2: 20.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_641_19",
    x1: 22.3124,
    y1: 23.8298,
    x2: 21.3681,
    y2: 22.3564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_641_19",
    x1: 23.852,
    y1: 23.9477,
    x2: 23.2827,
    y2: 23.0594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_641_19",
    x1: 21.0426,
    y1: 14.6134,
    x2: 23.2909,
    y2: 23.0989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_641_19",
    x1: 21.9994,
    y1: 20.3294,
    x2: 21.9994,
    y2: 23.7189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F32816",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    stopColor: "#E3281D",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#CA2728",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_641_19",
    x1: 34.325,
    y1: 17.8515,
    x2: 34.7933,
    y2: 16.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_641_19",
    x1: 33.2286,
    y1: 17.8637,
    x2: 33.5984,
    y2: 16.5331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_641_19",
    x1: 33.9183,
    y1: 18.8077,
    x2: 34.1413,
    y2: 18.0055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_641_19",
    x1: 21.0426,
    y1: 11.9601,
    x2: 23.2909,
    y2: 20.4455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_641_19",
    x1: 21.9995,
    y1: 18.0235,
    x2: 21.9995,
    y2: 20.8472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F32816",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    stopColor: "#E3281D",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#CA2728",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_641_19",
    x1: 21.0426,
    y1: 9.30682,
    x2: 23.2909,
    y2: 17.7924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_641_19",
    x1: 32.4198,
    y1: 11.9981,
    x2: 30.9772,
    y2: 9.7468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_641_19",
    x1: 31.4252,
    y1: 13.3852,
    x2: 30.2863,
    y2: 11.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_641_19",
    x1: 32.9401,
    y1: 13.5525,
    x2: 32.2535,
    y2: 12.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_641_19",
    x1: 34.2976,
    y1: 12.3602,
    x2: 34.8479,
    y2: 10.3793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_641_19",
    x1: 33.2068,
    y1: 12.3759,
    x2: 33.6412,
    y2: 10.8121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_641_19",
    x1: 33.9048,
    y1: 13.4982,
    x2: 34.1667,
    y2: 12.5555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_641_19",
    x1: 21.9995,
    y1: 14.8706,
    x2: 21.9995,
    y2: 18.5883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#F32816",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    stopColor: "#E3281D",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#CA2728",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_641_19",
    x1: 25.7682,
    y1: 18.7375,
    x2: 6.64097,
    y2: 4.02858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#F12817",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    stopColor: "#DD2820",
    stopOpacity: 0.611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_641_19",
    x1: 30.7046,
    y1: 21.0928,
    x2: 16.3987,
    y2: 13.8928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#F12817",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    stopColor: "#DD2820",
    stopOpacity: 0.611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_641_19",
    x1: 31.6768,
    y1: 17.8319,
    x2: 20.3827,
    y2: 10.5848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#F12817",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    stopColor: "#DD2820",
    stopOpacity: 0.611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_641_19",
    x1: 36.646,
    y1: 15.7928,
    x2: 32.3636,
    y2: 11.8163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#F12817",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    stopColor: "#DD2820",
    stopOpacity: 0.611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_641_19",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2582 6.50211) scale(18.6365 13.1387)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3126,
    stopColor: "#FFD643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5593,
    stopColor: "#FFCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7826,
    stopColor: "#FFBB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    stopColor: "#FFA426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_641_19",
    x1: 28.8866,
    y1: 11.1449,
    x2: 19.8042,
    y2: -8.57269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_641_19",
    x1: 17.9353,
    y1: 5.93804,
    x2: 20.3595,
    y2: 5.3001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_641_19",
    x1: 19.6809,
    y1: 3.87781,
    x2: 21.43,
    y2: 4.43132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_641_19",
    x1: 21.7273,
    y1: 5.3882,
    x2: 22.6371,
    y2: 8.20037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#FF8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#FF6C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_641_19",
    x1: 21.5648,
    y1: 5.98277,
    x2: 24.9837,
    y2: 10.4494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_641_19",
    x1: 20.1458,
    y1: 13.8049,
    x2: 44.1458,
    y2: -31.9363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPancake);
export default __webpack_public_path__ + "static/media/pancake.7dd62e123a986525edd1f68a72fb55fd.svg";
export { ForwardRef as ReactComponent };